import type { FC } from "react";
import React from "react";
import { APP_CONTENT_WIDTH_WITHOUT_PADDING } from "src/constants/layout";
import { KnownPartnerSources } from "src/constants/partner";
import Translate from "../Translate/Translate";
import styled from "@emotion/styled";
import ContinueWithPartnerButton from "./ContinueWithPartnerButton";

const Centered = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  max-width: var(--section-max-width);
`;

const ReAuthenticateUsingTranscarent: FC = () => {
  return (
    <Centered>
      <Content
        style={
          {
            "--section-max-width": `${APP_CONTENT_WIDTH_WITHOUT_PADDING}px`
          } as React.CSSProperties
        }
      >
        <nine-heading>
          <h3 className="as-h4-large">
            <Translate msg={"reauthenticate_title"} />
          </h3>
          <nine-spacer s="sm"></nine-spacer>
          <p className="m0 color-c-80">
            <Translate
              msg={"login.subtitle"}
              variables={{ context: "reauth_transcarent" }}
            />
          </p>
        </nine-heading>
        <nine-spacer s="md"></nine-spacer>
        <ContinueWithPartnerButton
          partner={KnownPartnerSources.transcarent}
          center
        />
      </Content>
    </Centered>
  );
};

export default ReAuthenticateUsingTranscarent;
